// imports
import React from 'react';
import EmptyList from '../../molecules/list/empty';
import Topbar from '../../molecules/tabView/topbar';
import ScrollableContainer from '../../atoms/container/scrollable';

// exports
export default function Activity(): JSX.Element {
  return (
    <div className="activity">
      <Topbar tabs={[
        { key: 'recent', onClick: () => undefined },
        { key: 'you', onClick: () => undefined }
      ]}
      />
      <ScrollableContainer><EmptyList text="Coming Soon" /></ScrollableContainer>
    </div>
  );
}
